import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import ReclamationForm from '../components/ReclamationForm';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import UpdateIcon from '@mui/icons-material/Update';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  paddingTop: '2rem',
  paddingBottom: '4rem',
  backgroundColor: '#F8FAFC'
}));

const ProcessSection = styled(Box)(({ theme }) => ({
  marginTop: '6rem',
  marginBottom: '4rem',
  textAlign: 'center'
}));

const ProcessTitle = styled(Typography)(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: '700',
  color: '#1E293B',
  marginBottom: '1rem'
}));

const ProcessSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  color: '#64748B',
  maxWidth: '800px',
  margin: '0 auto 4rem'
}));

const ProcessStep = styled(Box)(({ theme }) => ({
  padding: '2rem',
  height: '100%',
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  border: '1px solid #E2E8F0',
  transition: 'all 0.3s ease',
  position: 'relative',
  '&:hover': {
    transform: 'translateY(-8px)',
    borderColor: '#2563EB',
    '& .stepIcon': {
      backgroundColor: '#2563EB',
      color: '#FFFFFF'
    }
  }
}));

const StepIcon = styled(Box)(({ theme }) => ({
  width: '64px',
  height: '64px',
  borderRadius: '16px',
  backgroundColor: '#EFF6FF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1.5rem',
  transition: 'all 0.3s ease',
  '& svg': {
    fontSize: '32px',
    color: '#2563EB'
  }
}));

const StepNumber = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  fontSize: '3rem',
  fontWeight: '700',
  color: '#F1F5F9',
  opacity: 0.5
}));

const StepTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: '600',
  color: '#1E293B',
  marginBottom: '1rem'
}));

const StepDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#64748B',
  lineHeight: 1.6
}));

const processSteps = [
  {
    icon: <AssignmentTurnedInIcon />,
    title: 'Enregistrement Initial',
    description: 'Votre réclamation est immédiatement enregistrée dans notre système.'
  },
  {
    icon: <AnalyticsIcon />,
    title: 'Analyse Approfondie',
    description: 'Notre équipe qualité analyse en détail votre réclamation et identifie les actions correctives nécessaires.'
  },
  {
    icon: <UpdateIcon />,
    title: 'Suivi de la réclamation',
    description: 'Notre équipe vous informe des mesures prises et vous avez la possibilité de contacter à tout moment le service qualité pour assurer un suivi plus détaillé de votre réclamation.'
  },
  {
    icon: <CheckCircleIcon />,
    title: 'Clôture de la réclamation',
    description: 'Vous êtes informé par E-mail des conclusions approuvées de votre réclamation.'}
];

const Reclamation = () => {
  return (
    <PageContainer>
      <Container maxWidth="lg">
        <ReclamationForm />
        
        <ProcessSection>
          <ProcessTitle variant="h2">
            Notre Processus de Traitement
          </ProcessTitle>
          <ProcessSubtitle>
            Nous nous engageons à traiter chaque réclamation avec la plus grande attention, 
            en suivant un processus rigoureux pour garantir votre satisfaction
          </ProcessSubtitle>

          <Grid container spacing={4}>
            {processSteps.map((step, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <ProcessStep>
                  <StepNumber>{index + 1}</StepNumber>
                  <StepIcon className="stepIcon">
                    {step.icon}
                  </StepIcon>
                  <StepTitle>
                    {step.title}
                  </StepTitle>
                  <StepDescription>
                    {step.description}
                  </StepDescription>
                </ProcessStep>
              </Grid>
            ))}
          </Grid>
        </ProcessSection>
      </Container>
    </PageContainer>
  );
};

export default Reclamation;
